<template>
  <div class="content container">
    <kiosk-no-site v-if="noSiteId"/>
    <template v-else>
      <page-loader v-if="fetchingSites || fetchingSubscription || fetchingKioskSignInSetting"/>
      <template v-else>
        <kiosk-no-site v-if="sites.length < 1"/>
        <kiosk-no-subscription v-else-if="attemptedSubscription && !subscriptionFeatureAllowed"/>
        <kiosk-disabled v-else-if="signInDisabled"/>
        <slot v-else></slot>
      </template>
    </template>
  </div>
</template>

<script>
import { SiteCacheMixin } from '@/mixins/Booking/SiteCacheMixin'
import { SubscriptionCacheMixin } from '@/mixins/Booking/SubscriptionCacheMixin'
import { KioskSignInSettingCacheMixin } from '@/mixins/Kiosk/KioskSignInSettingCacheMixin'
import PageLoader from '../Loading/PageLoader.vue'
import KioskNoSite from './KioskNoSite.vue'
import KioskDisabled from './KioskDisabled.vue'
import KioskNoSubscription from './KioskNoSubscription.vue'

export default {
  name: 'KioskSettingsChecker',
  mixins: [SiteCacheMixin, SubscriptionCacheMixin, KioskSignInSettingCacheMixin],
  computed: {
    featureKey () {
      return 'clientCheckInKiosk'
    },
    noSiteId () {
      return !this.siteId
    },
    signInDisabled () {
      return !this.kioskSignInSettingError && !!this.kioskSignInSetting && !this.kioskSignInSettingEnabled
    }
  },
  components: {
    'page-loader': PageLoader,
    'kiosk-no-site': KioskNoSite,
    'kiosk-disabled': KioskDisabled,
    'kiosk-no-subscription': KioskNoSubscription
  }
}
</script>
